import './App.css';
import './index.css';
import './styles.scss';
import Layout from './layout';

function App() {
  return (<>
    <div className="App">
      <Layout />
    </div>
    </>
  );
}

export default App;
